<template>
  <section>
    <div class="detailInfo container">
      <div class="dl">
        <div class="show">
          <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <swiper-slide v-for="item in productImages" :key="item.imageId">
              <img :src="item.imageUrl"/>
            </swiper-slide>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </swiper>
        </div>
        <div class="productImages">
          <ul>
            <li v-if="productImages.length>4" class="prev" style="width: 20px;" @click="now > 0?(now=now-1):0"></li>
            <li @click="changeShow(index)" v-for="(item, index) in productImages"
                :key="item.imageId" :text="index - now">
              <img v-if="(productImages.length <= 4)||(productImages.length>4&&(index-now)<4&&(index-now)>=0)" :src="item.imageUrl"/>
            </li>
            <li v-if="productImages.length>4"  class="next" style="width: 20px;" @click="(now < (productImages.length-4))?(now=now+1):0"></li>
          </ul>
        </div>
      </div>
      <div class="dr">
        <div class="productName">车灯师D32 全新2代</div>
        <div class="productData">36W 4200LM</div>
        <div class="remark">功率升级到36W，亮度更高，流明值升级到4200LM，射程更远，氮化铝陶瓷芯片，更稳定，车灯师诠释中国制造水准的最新力作，不喧哗，自有声。</div>
        <div class="productPriceTitle">官方建议零售价：</div>
        <div class="productPrice">￥799.00</div>
        <div class="productUrl">立即购买</div>
        <div class="productBuyItem">
          <a target="_blank" href="https://item.jd.com/50306237093.html">
            <img src="http://video.naolamp.com/images/index/jd.png"/>
          </a>
          <a target="_blank" href="https://item.taobao.com/item.htm?spm=a1z10.1-c-s.w5003-20151169111.9.59f1480bIeNofd&id=584928302660&scene=taobao_shop">
            <img src="http://video.naolamp.com/images/index/tb.png"/>
          </a>
        </div>
      </div>
    </div>
    <div class="detailImage">
      <div class="item"  v-for="item in 18" v-bind:key="item">
        <img :src="getImg(item)"/>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'product32',
  props: {
  },
  data () {
    return {
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      categoryId: 0,
      proUrl: 'javascript:void(0);',
      show: false,
      now: 0,
      productImagesShow: 0,
      productImages: [{
        'imageId': 1,
        'imageUrl': 'http://video.naolamp.com/images/index/d321.jpg'
      }, {
        'imageId': 2,
        'imageUrl': 'http://video.naolamp.com/images/index/d322.jpg'
      }, {
        'imageId': 3,
        'imageUrl': 'http://video.naolamp.com/images/index/d323.jpg'
      }, {
        'imageId': 4,
        'imageUrl': 'http://video.naolamp.com/images/index/d324.jpg'
      }]
    }
  },
  computed: {},
  mounted: function (s) {
  },
  methods: {
    changeShow (i) {
      this.productImagesShow = i
      this.$refs.swiperTop.swiper.slideTo(i, 1000, false)
    },
    getImg (i) {
      return 'http://video.naolamp.com/images/index/d32_' + i + '.jpg'
    }
  },
  filters: {
  },
  components: {
  },
  watch: {}
}

</script>

<style scoped>
/*.detailImage {*/
  /*position: relative;*/
/*}*/
.detailInfo {
  width: 1200px;
  margin: 0 auto;
  padding-top: 50px;
}
.detailInfo .dl {
  width: 600px;
  float: left;
  padding-top: 30px;
  padding-right: 50px;
}
.gallery-thumbs {
  width: 480px;
  margin: 0 auto;
}
.gallery-thumbs img{
  width: 90px;
  height: 90px;
  padding-right: 25px;
}
.gallery-top {
  width: 567px;
  height: 567px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.detailInfo .dr {
  width: 397px;
  float: left;
  text-align: left;
  color: #191b1b;
}
.detailInfo .dl .show {
  width: 567px;
  height: 567px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.detailInfo .dl .productImages {
  width: 500px;
  margin: 0 auto;
  height: auto;
}
.productImages .prev, .productImages .next{
  background-color: #EEEEEE;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
}
.productImages .next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
}
.detailInfo .dl .productImages img {
  margin:0 12.5px;
  width: 90px;
}
.detailInfo .dl .productImages img:hover {
  opacity: .7;
  border-bottom: 2px solid #3c3c3c;
}
.detailInfo .dl .productImages ul li {
  height: 90px;
  float: left;
  padding-bottom: 15px;
  cursor: pointer;
}
.productName {
  padding-top: 85px;
  font-size: 32px;
}
.productData {
  font-size: 16px;
}
.remark {
  padding-top: 34px;
  font-size: 16px;
  padding-bottom: 67px;
  border-bottom: 1px solid #e5e5e5;
}
.productPriceTitle {
  padding-top: 40px;
  font-size: 16px;
  padding-bottom: 6px;
}
.productPrice {
  font-size: 28px;
  padding-bottom: 43px;
  border-bottom: 1px solid #e5e5e5;
}
.productUrl {
  padding-top: 41px;
  padding-bottom: 20px;
}
.productBuyItem a {
  padding-right: 16px;
}
.detailImage {
  padding-top: 50px;
}
.detailImage .item {
  color: #333;
  max-width: 1920px;
  text-align: center;
  margin:0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.detailImage img {
  width:100%;
  height:100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/product/detail/productD32.vue